<template>
  <v-app>
    <v-main class="light-blue accent-4 vm_bg">
      <v-card
        :loading="loading"
        class="mx-auto mt-10 pa-3"
        max-width="540"
      >
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          />
        </template>

        <v-img
          height="300"
          src="https://www.lsgj.cn/static/home/images/big-data.jpg"
        />
        <br><br>
        <validation-observer
          ref="observer"
        >
          <form @submit.prevent="submit">
            <validation-provider
              v-slot="{ errors }"
              name="用户名"
              :rules="{
                required: true,
                max: 20,
                min: 3
              }"
            >
              <v-text-field
                v-model="name"
                :counter="20"
                :error-messages="errors"
                label="用户名"
              />
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="密码"
              :rules="{
                required: true,
                max: 20,
                min: 6
              }"
            >
              <v-text-field
                v-model="password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                :counter="20"
                :error-messages="errors"
                label="密码"
                @click:append="show1 = !show1"
              />
            </validation-provider>
            <br>
            <!--<validation-provider
              v-slot="{ errors }"
              name="email"
              rules="required|email"
            >
              <v-text-field
                v-model="email"
                :error-messages="errors"
                label="E-mail"
                required
              ></v-text-field>
            </validation-provider>-->

            <v-btn
              class="mr-4"
              type="submit"
            >
              Login
            </v-btn>
            <v-btn @click="clear">
              reset
            </v-btn>
          </form>
        </validation-observer>
      </v-card>
    </v-main>
  </v-app>
</template>
<script>
  import { required, max, min } from 'vee-validate/dist/rules'
  import { mapMutations } from 'vuex'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import axios from 'axios'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_}不能为空！',
  })

  extend('max', {
    ...max,
    message: '{_field_}不能超过{length}个字符',
  })

  extend('min', {
    ...min,
    message: '{_field_}不能低于{length}个字符',
  })

  /*
  extend('digits', {
    ...digits,
    message: '{_field_} needs to be {length} digits. ({_value_})',
  })

  extend('regex', {
    ...regex,
    message: '{_field_} {_value_} does not match {regex}',
  })

  extend('email', {
    ...email,
    message: 'Email must be valid',
  })**/

  export default {
    name: 'LoginView',
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    data: () => ({
      loading: false,
      show1: false,
      name: '',
      password: '',
      email: '',
    }),
    methods: {
      ...mapMutations(['changeLogin', 'changeroles']),
      submit () {
        this.$refs.observer.validate()
        const _this = this
        axios
          .post(process.env.VUE_APP_BASE_API + '/user/login', {
            username: this.name,
            password: this.password,
          })
          .then(response => {
            // console.log(response.data.code)
            if (response.data.code === 20000) {
              _this.userToken = 'Bearer ' + response.data.data.token
              _this.userInfo = response.data.data.userInfo
              localStorage.setItem('roles', _this.userInfo.roles)
              // console.log(localStorage.getItem('roles'))
              // console.log(_this.roles)
              // 将用户token保存到vuex中
              _this.changeLogin({ Authorization: _this.userToken })
              // console.log(response.data.data.userInfo)
              _this.changeroles(response.data.data.userInfo)
              // localStorage.setItem('userInfo', response.data.data.userInfo)
              _this.$router.push('/')
              this.$message.success('登录成功')
            } else {
              this.$message.error(response.data.message)
              // alert(response.data.message)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      clear () {
        this.name = ''
        this.password = ''
        this.$refs.observer.reset()
      },
    },
  }
</script>
<style scoped>
  .vm_bg{
    background: url("https://www.lsgj.cn/static/home/images/blue-bg.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
  }
</style>
